import React from 'react';
import {generatePaddingClasses} from '@pb/kit-util-generate-padding-classes';
import {withCssModule} from '@pb/kit-util-with-css-module';

import {AlignItem, ALIGN_ITEM_CLASSES} from './constants';
import styles from './element-group.module.styl';

import type {ReactNode} from 'react';
import type {PaddingType} from '@pb/kit-util-generate-padding-classes';
import type {AlignItemType} from './constants';


const classNames = withCssModule(styles);

/**
 * @description ItemProps
 */
export interface ItemProps {
    /**
     * Align self on the cross axis
     */
    align?: AlignItemType,
    /**
     * Item calculate width relatively to others Items
     */
    catch?: boolean,
    /**
     * ElementGroup Item children
     */
    children?: ReactNode,
    /**
     * Should Item grow (flex-grow: 1 meaning)
     */
    grow?: boolean,
    /**
     * Max allowed Item width
     */
    maxWidth?: string | number,
    /**
     * ClassName for ElementGroup Item
     */
    mix?: string,
    /**
     * Custom Item padding
     */
    padding?: PaddingType,
    /**
     * Should not Item shrink (flex-shrink: 0 meaning)
     */
    shrink?: boolean,
    /**
     * Specified Item width
     */
    width?: string | number,
}

/**
 * @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-group` instead
 * @see [Group]{@link https://storybook.dev.pitchbookdata.com/?path=/docs/layout-group--documentation}
 * */
export const Item = (props: ItemProps) => {
    const {
        align = AlignItem.AUTO,
        catch: catchWidth = false,
        grow = false,
        mix = '',
        padding,
        children,
        maxWidth,
        shrink,
        width,
    } = props;

    const itemProps = {
        style: {
            ...width ? {width} : {},
            ...width ? {minWidth: width} : {},
            ...maxWidth ? {maxWidth} : {},
        },
        className: classNames(
            'element-group__item',
            ALIGN_ITEM_CLASSES[align],
            padding ? generatePaddingClasses('element-group__item', padding) : '',
            mix,
            {
                'element-group__item_grow': grow,
                'element-group__item_shrink': shrink,
                'element-group__item_catch': catchWidth,
            },
        ),
    };

    return <div {...itemProps}>{children}</div>;
};

Item.displayName = 'Item';
